import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum VapiCallFields {
    CALL_ID = 'callId',
    SECRET = 'secret',
    PHONE_NUMBER = 'phoneNumber',
    PROFILE = 'profile',
    PROFILE_TYPE = 'profileType',
    SUMMARY = 'summary',
    ASSISTANT = 'assistant',
    RECORDING_URL = 'recordingUrl',
    DURATION = 'duration',
    STRUCTURED_DATA = 'structuredData',
    CREATOR = 'creator',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace VapiCallFields {
    type Data = { text: string; readonly?: true; updateOnly?: true; };

    export const Record: Record<VapiCallFields, Data> = {
        [VapiCallFields.CALL_ID]: {
            text: 'Anruf-ID',
            readonly: true,
        },
        [VapiCallFields.SECRET]: {
            text: 'Secret',
            readonly: true,
        },
        [VapiCallFields.PHONE_NUMBER]: {
            text: 'Externe Telefonnummer',
            readonly: true,
        },
        [VapiCallFields.PROFILE]: {
            text: 'Profil',
            readonly: true,
        },
        [VapiCallFields.PROFILE_TYPE]: {
            text: 'Profiltyp',
            readonly: true,
        },
        [VapiCallFields.SUMMARY]: {
            text: 'Zusammenfassung',
            readonly: true,
        },
        [VapiCallFields.ASSISTANT]: {
            text: 'Assistent',
            readonly: true,
        },
        [VapiCallFields.RECORDING_URL]: {
            text: 'Aufnahme-URL',
            readonly: true,
        },
        [VapiCallFields.DURATION]: {
            text: 'Dauer',
            readonly: true,
        },
        [VapiCallFields.STRUCTURED_DATA]: {
            text: 'Strukturierte Daten',
            readonly: true,
        },
        [VapiCallFields.CREATOR]: {
            text: 'Ersteller',
            readonly: true,
        },
        [VapiCallFields.CREATED_AT]: {
            text: 'Erstellt am',
            readonly: true,
        },
        [VapiCallFields.UPDATED_AT]: {
            text: 'Aktualisiert am',
            readonly: true,
        },
    }

    export const Items = mapRecordToItems(Record);
}
